import dayjs from 'dayjs';

export function formatTime(seconds: number) {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
}

// utils/sessionUtils.ts
export function generateSessions(startOffset = -1, numberOfYears = 10): string[] {
  const currentYear = new Date().getFullYear();
  const startYear = currentYear + startOffset;
  const sessions: string[] = [];

  for (let i = 0; i < numberOfYears; i++) {
    const year1 = startYear + i;
    const year2 = year1 + 1;
    sessions.push(`${year1}/${year2}`);
  }

  return sessions;
}

export function formatDateTime(datetime: string): string {
  const date = new Date(datetime);
  const pad = (n: number) => n.toString().padStart(2, '0');

  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

// Get today's date
const today = dayjs();
// Function to get days in the current calendar month view, including today check
export const getCalendarDays = (date: dayjs.Dayjs) => {
  const startOfMonth = date.startOf('month');
  const endOfMonth = date.endOf('month');

  // First day of the month (for alignment in the grid)
  const firstDayIndex = startOfMonth.day();

  // Last day index (to get number of empty days after the last day of the month)
  const lastDayIndex = endOfMonth.day();

  // Total days in month
  const daysInMonth = endOfMonth.date();

  // Generate days before the first day of the month to fill the calendar grid
  const days = [];
  for (let i = 0; i < firstDayIndex; i++) {
    days.push({ date: null, isCurrentMonth: false, isToday: false });
  }

  // Add days for the current month
  for (let i = 1; i <= daysInMonth; i++) {
    const currentDay = date.date(i);
    days.push({
      date: i,
      isCurrentMonth: true,
      isToday: currentDay.isSame(today, 'day'), // Check if today
    });
  }

  // Fill the remaining days of the week after the last day of the month
  for (let i = lastDayIndex + 1; i < 7; i++) {
    days.push({ date: null, isCurrentMonth: false, isToday: false });
  }

  return days;
};

export function debounce<T extends(...args: unknown[]) => unknown>(fn: T, delay: number) {
  let timeoutId: ReturnType<typeof setTimeout> | null = null;
  return function(this: unknown, ...args: Parameters<T>) {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}
